import React, { useEffect, useState, useRef } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import styles from './patientHomeDetail.module.scss';
import  { ApiCore } from '../../../api/index';
import utils from '../../../utils/utils';
import CRFComponent from '../../../component/crf/crf';
import { Toast } from 'antd-mobile';
const api = new ApiCore();

function PatientHomeDetail(props: any) {

    const [formData, setFormData] = useState<any>({});
    const [initFormData, setInitFormData] = useState<any>({});
    const [formState, setFormState] = useState<number>(-1);

    const CrfRef: any = useRef();
    const history: any = useHistory();

    useEffect(() => {
        initData();
        return () => {
        }
    }, [])

    const initData = () => {
        const formData = props.patientHomeDetailData || sessionStorage.getItem('PatientHomeDetailData');
        if (formData) {
            let _token: any = {};
            try {
                _token = JSON.parse(sessionStorage.getItem('token') || '{}');
            } catch (error) {
                _token = {};
            }
            let _formData: any = JSON.parse(formData);
            let __formData = {
                channel: _formData.channel,
                tenantCode: _formData.tenantCode,
                caseCode: _formData.caseCode,
                eventCode: _formData.event.code,
                crfVersion: _formData.task.formVersion,
                crfCode: _formData.task.formCode,
                recordCode: _formData.task.code,
                userCode: _token.userCode
            };
            setFormData(__formData);
            setFormState(_formData.event.state);
            setInitFormData(_formData);
        }
    }

    /**
     * 保存表单内容
     */
     const handleSave = () => {
        CrfRef.current.handleSave()
    }

  /**
    * 表单内容保存成功的回调
    * @param savedData 
    */
    const onSaveSuccess = (savedData: any) => {
        if (formState == 4) {
            // 节点完成
            if (initFormData.event.nodeType == 4) {// 建档节点 完善个人信息
                const _map = {};
                (savedData.values || []).forEach((val: any) => {
                    _map[val.dataCode] = val.value
                });
                api.updatePatientInfo({
                    formDatas: _map,
                    caseCode: initFormData.caseCode
                }).then((res: any) => {
                    if (res.code == 0) {
                        Toast.success('保存成功');
                        history.goBack()
                    }
                });
            } else {
                Toast.success('保存成功');
                history.goBack()
                return;
            }
        } else if (initFormData.task.state !== 2) {
            // 2为当前任务已完成
            const _map = {};
            (savedData.values || []).forEach((val: any) => {
                _map[val.dataCode] = val.value
            });
            api.finishTask({
                eventCode: initFormData.event.code,
                taskCode: initFormData.task.code,
                formDatas: _map
            }).then((res: any) => {
                if (res.code == 0) {
                    Toast.success('保存成功');
                    history.goBack()
                } else {
                    Toast.success(res.message || '保存失败');
                }
            });
        }
    }

    return (
        <div className={`${styles.patientHomeDetail_content} ${props.inPrePage ? styles.noFullScreen : styles.fullScreen}`}>
            <div className={styles.crfContent}>
            {
                formData && Object.keys(formData).length > 0 &&
                <CRFComponent
                    ref={CrfRef}
                    params={formData}
                    onSaveSuccess={(v: any) => onSaveSuccess(v)}
                />
            }
            </div>
            <div className={styles.actonBtns}>
                <div className={styles.backBtn} onClick={() => history.goBack()}>返回</div>
                <div className={styles.nextBtn} onClick={handleSave}>
                    {formState == 4 ? '保存' : '完成'}
                </div>
            </div>
        </div>
    )

}

export default withRouter(PatientHomeDetail);